import { type ReactNode, useEffect } from 'react';
import { useStepperDialog } from '@ics-portal/guardian';
import { hasDirtyFields } from '@utils/hasDirtyFields';
import { useProjectFormContext } from '../../ProjectForm';
import { ProjectFormRequirements } from './ProjectFormRequirements';

interface ProjectFormRequirementsStepProps {
    isEditMode?: boolean;
}

export function ProjectFormRequirementsStep({
    isEditMode,
}: ProjectFormRequirementsStepProps): ReactNode {
    const { registerProceed, setPrimaryDisabled } = useStepperDialog();
    const { form } = useProjectFormContext();
    const {
        formState: { dirtyFields },
    } = form;
    const hasUnsavedChanges = hasDirtyFields(dirtyFields);

    useEffect(() => {
        registerProceed(() => {
            return true;
        });
    }, [registerProceed]);

    useEffect(() => {
        setPrimaryDisabled(Boolean(isEditMode) && !hasUnsavedChanges, {
            isInvalid: false,
        });
    }, [setPrimaryDisabled, isEditMode, hasUnsavedChanges]);

    return <ProjectFormRequirements />;
}
